import React from "react";
import { Link } from "react-router-dom";
import "../css/ManagementTeam.css";

const heroImage = "./images/i.jpeg";

const chairmanImage = "./images/principal.jpg";

const ManagementTeam = () => {
  return (
    <>
      {}

      <section
        className="management-hero"
        style={{ backgroundImage: `url(${heroImage})` }}
      >
        <div className="management-overlay">
          <div className="container">
            <span className="hero-badge">Leadership</span>

            <h1>
              Meet Our
              <span> Leadership Team</span>
            </h1>

            <p>
              Dedicated educators and visionary leaders committed to providing
              quality education and nurturing every student's potential.
            </p>

            <div className="hero-buttons">
             <Link to="/contact" className="primary-btn">
  Contact Us
</Link>

     <Link to="/about" className=" outline-btn">
  Learn More
</Link>
            </div>
          </div>
        </div>
      </section>

      {}

      <section className="chairman-section">
        <div className="container chairman-wrapper">
          <div className="chairman-image">
            <img src={chairmanImage} alt="Chairman" />
          </div>

          <div className="chairman-content">
            <span className="section-tag">Chairman's Message</span>

            <h2>Inspiring Excellence Through Quality Education</h2>

            <p>
              At Sahara Public School Nepal, our vision is to provide every
              child with an education that develops confidence, creativity,
              discipline and strong moral values.
            </p>

            <p>
              We believe every student possesses unique talents. Our
              responsibility is to create an environment where those talents
              flourish through innovative learning, experienced teachers and
              holistic development.
            </p>

            <p>
              Together with parents and our dedicated faculty, we continue
              building a future where students become responsible citizens and
              lifelong learners.
            </p>

            <div className="chairman-info">
              <h3>Mr. Ghufran Ahmad Shakir</h3>

              <span>Chairman • Sahara Public School Nepal</span>
            </div>
<Link to="/contact" className="primary-btn">
  Contact Chairman
</Link>
          </div>
        </div>
      </section>
      {}

      <section className="leadership-section">
        <div className="container">
          <div className="section-heading">
            <span>School Leadership</span>

            <h2>Guiding Every Student Towards Success</h2>

            <p>
              Our experienced leadership team works together to provide an
              inspiring learning environment where every student can achieve
              academic excellence and personal growth.
            </p>
          </div>

          <div className="leadership-grid">
            <div className="leader-card">
              <img
                src="./images/principal.jpg"
                alt="Principal"
              />

              <div className="leader-content">
                <h3>Mr. Ghufran Ahmad Shakir</h3>

                <span>Principal</span>

                <p>
                  Leading Sahara Public School with a vision of academic
                  excellence, innovation and holistic student development.
                </p>
              </div>
            </div>

            <div className="leader-card">
              <img
                src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=700&auto=format&fit=crop&q=80"
                alt="Vice Principal"
              />

              <div className="leader-content">
                <h3>Mrs. Anita Sharma</h3>

                <span>Vice Principal</span>

                <p>
                  Supporting students and teachers by creating a positive,
                  inclusive and future-focused learning environment.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {}

      <section className="management-team">
        <div className="container">
          <div className="section-heading">
            <span>Management Team</span>

            <h2>Meet Our Dedicated Professionals</h2>
          </div>

          <div className="management-grid">
            <div className="management-card">
              <img
                src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=700&auto=format&fit=crop&q=80"
                alt=""
              />

              <h3>Mr. Ramesh Gautam</h3>

              <span>Academic Coordinator</span>
            </div>

            <div className="management-card">
              <img
                src="https://images.unsplash.com/photo-1517841905240-472988babdf9?w=700&auto=format&fit=crop&q=80"
                alt=""
              />

              <h3>Mrs. Sunita Karki</h3>

              <span>Administration Head</span>
            </div>

            <div className="management-card">
              <img
                src="https://images.unsplash.com/photo-1504593811423-6dd665756598?w=700&auto=format&fit=crop&q=80"
                alt=""
              />

              <h3>Mr. Bikash Thapa</h3>

              <span>Senior Coordinator</span>
            </div>

            <div className="management-card">
              <img
                src="https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=700&auto=format&fit=crop&q=80"
                alt=""
              />

              <h3>Mrs. Priya Sharma</h3>

              <span>Student Welfare Head</span>
            </div>

            <div className="management-card">
              <img
                src="https://images.unsplash.com/photo-1504257432389-52343af06ae3?w=700&auto=format&fit=crop&q=80"
                alt=""
              />

              <h3>Mr. Rohit Adhikari</h3>

              <span>Sports Coordinator</span>
            </div>

            <div className="management-card">
              <img
                src="https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?w=700&auto=format&fit=crop&q=80"
                alt=""
              />

              <h3>Mrs. Neha Singh</h3>

              <span>Examination In-charge</span>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ManagementTeam;
